let UTILS = require("../libs/utils.js");
var v7687;
var v7688;
module.exports = {
  id: "infect",
  name: "Infected",
  alias: "infect",
  endStats: ["sid", "name", "score", "kills", "infected", "reward"],
  winCondition: function (game) {
    var vLN01175 = 0;
    for (var vLN01176 = 0; vLN01176 < game.players.list.length; ++vLN01176) {
      if (game.players.list[vLN01176].active && game.players.list[vLN01176].team == 1) {
        vLN01175++;
      }
    }
    if (vLN01175 > 0) {
      return 1;
    } else {
      return 2;
    }
  },
  condition: [function (game) {
    var vLN01177 = 0;
    for (var vLN01178 = 0; vLN01178 < game.players.list.length; ++vLN01178) {
      if (game.players.list[vLN01178].active && game.players.list[vLN01178].team == 1) {
        vLN01177++;
      }
    }
    return vLN01177 > 0;
  }],
  minPlayers: 2,
  waitTimers: [{
    time: 20000,
    msg: "infection in ",
    trigger: function (p9073) {
      p9073.infectRandom();
    }
  }],
  teamClass: {
    2: 9
  },
  spdMlt: {
    2: 1.15
  },
  killConv: true,
  noKick: true,
  teams: true,
  teamOptions: ["Survivors", "Infected"],
  convWord: "infected",
  convTeam: 2,
  modelOverrides: {
    Infected: {
      headIndex: 122,
      skinColor: 5857617
    }
  }
};